import { DetailAction } from '../../detail/actions/DetailAction';
import { SelectOptionDialog } from '../../../components/option/SelectOptionDialog';
import { FilterState, listFilterType } from '../../../pages/content/listPage/FilterState';
import { EpgApi } from '../../../api/EpgApi';
import { EpgUtil } from '../../utility/EpgUtil';
import { Backend } from '../../../api/Backend';
import { ChannelModel } from '../../../api/EpgApi.types';
import { OptionData } from '../../../components/option/OptionData';

export class ListChannelFilterActionHandler extends DetailAction {
  private filterState: FilterState;
  private filterSubscription: any;
  private channelsList: ChannelModel[] | undefined;
  private tags: OptionData | undefined;
  private day: Date | undefined;
  constructor(backend: Backend, filterState: FilterState) {
    super(backend);
    this.filterState = filterState;
    this.filterSubscription = this.filterStateChanged.bind(this);
    this.filterState.subscribe(this.filterSubscription);
  }

  override doAction() {
    this._getChannelsList().then(channels => {
      const options = channels.map(channel => ({
        text: channel.text.title,
        value: channel,
      }));

      this.owner?.fireAncestors('$openDialog', {
        type: SelectOptionDialog,
        params: {
          backend: this._backend,
          options: options,
          onSuccess: (val: OptionData) => {
            this.optionSelected(val);
          },
          onCancelled: this.hideOptions.bind(this),
        },
      });
    });
  }

  _getChannelsList(): Promise<ChannelModel[]> {
    if (this.channelsList) return Promise.resolve(this.channelsList);

    //todo replay
    const fromUntil = EpgUtil.fromUntilFromTime(this.day ? this.day : new Date(), false);
    return this._backend.cachedChannelApi.validChannels(this._backend, false).then(channels => {
      return EpgApi.channelsWithTags(
        this._backend,
        this.tags ? this.tags.value : [],
        fromUntil.from,
        fromUntil.until
      ).then(channelIds => channels.validChannels.filter(channel => channelIds.includes(channel.channelId)));
    });
  }

  optionSelected(option: OptionData) {
    this.filterState.updateState(listFilterType.channel, option.value.text.title, option.value);
    // this.filter.rating = option;
    // this._callback(this.filter);
    this.hideOptions();
  }

  hideOptions() {
    this.owner?.fireAncestors('$closeDialog');
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  filterStateChanged(type: string, value: OptionData) {
    //if its a tag, update the channellist
    if (type === listFilterType.tag || type === listFilterType.day || type === listFilterType.all) {
      this.channelsList = undefined;
      const dayFilter = this.filterState.stateOf(listFilterType.day);
      this.tags = this.filterState.stateOf(listFilterType.tag);
      this.day = dayFilter ? dayFilter.value : undefined;
    }
  }
}
